import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ClinicInfo } from '../models/clinic.model';

@Injectable({
    providedIn: 'root'
})
export class ClinicService {
    constructor(private readonly http: HttpClient) { }

    getClinicInfo$(providerNumber: string): Observable<ClinicInfo> {
        return this.http.get<ClinicInfo>(`${environment.backendUrl}/clinic/getclinicbyprovidernumber`, { params: { providerNumber } })
    }

    setClinicSendEdi$(sendEdi: Boolean): Observable<Boolean> {
        return this.http.post<Boolean>(`${environment.backendUrl}/clinic/UpdateSendEdi`, sendEdi)
    }
}
